import { Vote } from "@/types/vote";

/**
 * Current active vote
 * This is a temporary constant for Phase 1 (static vote)
 * Phase 2 will fetch this data from the backend API
 */
export const CURRENT_VOTE: Vote = {
    id: "123e4567-e89b-12d3-a456-426614174000",
    question: "청량한 광고에 가장 잘 어울리는 모델은?",
    description: "여러분의 의견을 들려주세요!",
    options: [
        { id: 0, text: "츄" },
        { id: 1, text: "안유진" }
    ],
    participantCount: 0
};
